import axios from '@/axios.js'

export default {
  fetchEventsV2 ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/operation/calendarv2/data')
        .then((response) => {
          commit('SET_EVENTS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchEvents ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/operation/calendar/data')
        .then((response) => {
          commit('SET_EVENTS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  /*fetchEventLabels ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/apps/calendar/labels')
        .then((response) => {
          commit('SET_LABELS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }*/
}
